import "../App.css";
import Navbar from "../components/navbar/Navbar.js";
import Header from "../components/header/Header.js";
import Contact from "../components/contact/Contact.js";
import Footer from "../components/footer/Footer.js";
import AboutUs from "../components/about-us/AboutUs.js";
import BlurredContent from "../components/BlurredContent.js";
import SocialMedia from "../components/SocialMedia.js";
import YoloBot from "../components/chat-bot/chatBot.js";

const QuienesSomos = () => {
    return (
        <div className="size">
            <Navbar />
            <SocialMedia/>
            <YoloBot/>
            <BlurredContent>
                <Header />
                <AboutUs />
                <Contact />
            </BlurredContent>
            <Footer />
        </div>
    );
}

export default QuienesSomos;
